import { db } from './db';

const DEV_DATA_VERSION_KEY = 'audit-system:dev-data-version';
const DEV_DATA_PRESERVE_FLAG_KEY = 'audit-system:preserve-custom-data';
const DEV_SEED_GENERATION_TAG = '2026-01-01';

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);

export const CURRENT_DEV_DATA_VERSION = `schema-${db.verno}-seed-${DEV_SEED_GENERATION_TAG}`;

export async function readStoredDevDataVersion(): Promise<string | undefined> {
  const row = await db.kv.get(DEV_DATA_VERSION_KEY);
  const value = row?.value;
  return typeof value === 'string' ? value : undefined;
}

export async function writeCurrentDevDataVersion(): Promise<void> {
  await db.kv.put({
    key: DEV_DATA_VERSION_KEY,
    value: CURRENT_DEV_DATA_VERSION,
  });
}

export function isLocalHost(hostname?: string): boolean {
  const targetHost = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');

  if (!targetHost) {
    return false;
  }

  if (LOCAL_HOSTNAMES.has(targetHost)) {
    return true;
  }

  return targetHost.endsWith('.local');
}

export function isPreserveCustomDataEnabled(): boolean {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return false;
  }

  return window.localStorage.getItem(DEV_DATA_PRESERVE_FLAG_KEY) === 'true';
}

export function setPreserveCustomDataEnabled(enabled: boolean): void {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return;
  }

  if (enabled) {
    window.localStorage.setItem(DEV_DATA_PRESERVE_FLAG_KEY, 'true');
  } else {
    window.localStorage.removeItem(DEV_DATA_PRESERVE_FLAG_KEY);
  }
}
